import { render, staticRenderFns } from "./fccProjetosNucleoSolicitante.vue?vue&type=template&id=2dfa359f"
import script from "./fccProjetosNucleoSolicitante.vue?vue&type=script&lang=js"
export * from "./fccProjetosNucleoSolicitante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports